export default __webpack_public_path__ + "static/media/hudlImg.4befdd40.png";